export default __webpack_public_path__ + "static/O0054-3748657dea30c56102697e5882c8c227.png";